export const InternalError = 'Some thing went wrong, please try again later';

// Bot response error
export const SessionExpiredError = 'Your session is expired due to inactivity';
export const ClientNotExistError = 'The client does not exist';
export const ResponseDelayError =
    "I'm experiencing delays getting a response for that, please bear with me and try again shortly";
export const NotProcessedError = 'Your request could not be processed. Please try again later.';
export const AgentNotSelectedError = 'Please select a bot';

// Slot form error
export const InvalidPhoneNumberError = 'Invalid phone number';
export const InvalidEmailAddress = 'Invalid email address';
export const fieldRequiredError = 'Field is required';
export const MustBeNumberError = 'Must be a number';
